module.exports = __webpack_public_path__ + "static/media/icon__zoom-map.fc1ecfb3.svg";